import React, { FC } from 'react';
import { Container, Row, Col } from 'styled-bootstrap-grid';
import { Box } from '@ch/common/components/box';
import { useData } from '../use-data';
import { Navigate, useParams } from 'react-router-dom';
import {
  countriesLegalNotice,
  japanLegalNoticeContent,
  japanLegalNoticeENContent,
  koreanLegalNoticeContent,
  koreanLegalNoticeENContent,
  RoutePath,
} from '../const';
import { useLang } from '../use-lang';

const LegalNotice: FC = () => {
  const { country } = useParams();
  const { lang } = useLang();
  const {
    data: {
      pages: { legalNotice, japanLegalNotice, koreanLegalNotice },
    },
  } = useData();

  if (!countriesLegalNotice?.includes(country as string) && country !== undefined) {
    return <Navigate to={RoutePath.HOME} />;
  }

  return (
    <>
      <Box $p={[50, 0]}>
        <Container>
          <Row>
            <Col>
              {country ? (
                <>
                  {country === 'japan' && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: japanLegalNotice?.replaceAll(
                          '{japan_legal_notice}',
                          lang === 'ja' ? japanLegalNoticeContent : japanLegalNoticeENContent,
                        ),
                      }}
                    />
                  )}
                  {country === 'korean' && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: koreanLegalNotice?.replaceAll(
                          '{korean_legal_notice}',
                          lang === 'ko' ? koreanLegalNoticeContent : koreanLegalNoticeENContent,
                        ),
                      }}
                    />
                  )}
                </>
              ) : (
                legalNotice && <div dangerouslySetInnerHTML={{ __html: legalNotice }} />
              )}
            </Col>
          </Row>
        </Container>
      </Box>
    </>
  );
};

export default LegalNotice;
